module.exports = __webpack_public_path__ + "static/img/tu1.ae1fdcc4.png";